/**
 * Agents that use the generic `AgentConfigPage` but should also show the Audience-style
 * Basic Information block (org/workspace scope + rename) above Organization/Workspace tabs.
 */
/* eslint-disable i18next/no-literal-string -- agent registry ids */
export const AGENT_IDS_WITH_BASIC_INFORMATION_ON_AGENT_CONFIG_PAGE = new Set<string>([
  'flow-digest-agent',
  'strategy-agent-v3',
  'ideation-brief-intake',
  'translation-agent',
  'sentinel-buddy-agent',
  'email-flow-agent',
  'templates',
  'image-generation',
  'doughboy-image-agent',
  'copy-generation',
  'video-generation',
  'ideation',
]);
/* eslint-enable i18next/no-literal-string */
